$(document).ready(function () {

	jQuery.each(jQuery('.swiper--paralelo[data-module="swiper"]'), function () {
		var slider = this;
		var $slider = $(slider);
		var slider_delay = $slider.data('delay') || 5000;
		var slider_speed = $slider.data('speed') || 1000;
		var slider_horizontal = $slider.data('horizontal') == 'right' ? true : false;
		var slider_vertical = $slider.data('vertical') == 'down' ? true : false;

		const swiper = new Swiper(slider, {
			init: false, //el slider no se inicializa hasta que ambos estén completos
			slidesPerView: 1,
			direction: getDirection(),
			effect: 'slide',
			loop: true,
			speed: slider_speed,
			autoplay: {
				delay: slider_delay,
				// aplicar movimiento horizontal 👉🏼
				reverseDirection: slider_horizontal
			},
			pagination: {
				el: '.swiper-pagination',
				type: 'bullets',
				clickable: false
			},
			on: {
				resize: function () {
					swiper.changeDirection(getDirection());
				},
			},
			breakpoints: {
				// ventanas mayores a 768, o sea escritorio
				// aplicar movimiento vertical 👆🏼
				768: {
					autoplay: {
						reverseDirection: slider_vertical
					}
				},
			}
		});

		//cuando todo esté cargado, dale init a los sliders
		var everythingLoaded = setInterval(function () {
			if (/loaded|complete/.test(document.readyState)) {
				clearInterval(everythingLoaded);
				swiper.init();
			}
		}, 0);
	});

	jQuery.each(jQuery('.swiper--carousel[data-module="swiper"]'), function () {
		var slider = this;
		var $slider = $(slider);
		var slider_speed = $slider.data('speed') || 1000;
		var slider_parent = $slider.data('swiper-heritage');

		const big_swiper = new Swiper(slider, {
			slidesPerView: 1.2,
			slidesOffsetAfter: 16,
			slidesOffsetBefore: 16,
			spaceBetween: 16,
			effect: 'slide',
			loop: true,
			speed: slider_speed,
			autoplay: false,
		});

	});

	jQuery.each(jQuery('.swiper--carousel[data-module="swiper-double"]'), function () {
		var slider = this;
		var $slider = $(slider);
		var slider_speed = $slider.data('speed') || 1000;
		var slider_parent = $slider.data('swiper-heritage');

		const big_swiper = new Swiper(slider, {
			slidesPerView: 2,
			spaceBetween: 16,
			effect: 'slide',
			loop: true,
			speed: slider_speed,
			autoplay: false,
		});

	});

	jQuery.each(jQuery('.swiper--comunas[data-module="swiper-comunas"]'), function () {
		var slider = this;
		var $slider = $(slider);
		var slider_speed = $slider.data('speed') || 1000;
		var slider_parent = $slider.data('swiper-heritage');

		var swiper_slider = new Swiper(slider, {
			slidesPerView: 1.2,
			spaceBetween: 10,
			// centeredSlides: true,
			speed: slider_speed,
			pagination: {
				el: '[data-swiper-parent="' + slider_parent + '"] .swiper-pagination5',
				type: 'bullets',
				clickable: true,
			},
			navigation: {
				nextEl: '[data-swiper-parent="' + slider_parent + '"] .swiper-button-next',
				prevEl: '[data-swiper-parent="' + slider_parent + '"] .swiper-button-prev',
			},
			breakpoints: {
				500: {
					slidesPerView: 1.2,
					spaceBetween: 8,
					centeredSlides: true,
				},
				850: {
					slidesPerView: 3,
					allowTouchMove: true,
					centeredSlides: false,
				}
			}
		});
	});

	function getDirection() {
		var windowWidth = window.innerWidth;
		var direction = window.innerWidth > 768 ? 'vertical' : 'horizontal';
		return direction;
	}
});